import { axios } from 'Lib/axios'
import { useQuery } from '@tanstack/react-query'
import { ExtractFnReturnType } from 'Lib/react-query'
import { useUserStore } from 'Stores/userStoreModuleFed'
import { User } from 'Types/User'

type GetUsersResponse = {
  users: Array<User>
}

type QueryFnType = typeof getUsers

export const useGetUsers = () => {
  const accountId = useUserStore.getState().accountId

  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['users', accountId],
    queryFn: () => getUsers(accountId),
  })
}

const getUsers = (accountId: number): Promise<GetUsersResponse> | Error => {
  try {
    return axios
      .get<{ data: GetUsersResponse }>(`accounts/${accountId}/users`)
      .then((res) => res.data.data)
  } catch (e) {
    return e as Error
  }
}
